// Feedback QR on receipts (Pro, 2026-10-10). The owner enters a link in
// Settings > POS > Receipt Content (businesses.settings.receiptQrUrl); the
// receipt prints it as a QR code under the custom footer. One matrix feeds
// both renderers: an inline SVG for the HTML receipt (receiptView.js) and a
// raster image for ESC/POS thermal printers (escpos.js).
import qrcode from "qrcode-generator";

export const QR_URL_MAX = 300;

// https only (a receipt QR is scanned by customers - no javascript:/data:
// links, no plain http). set_business_settings applies the same rule.
export const isValidQrUrl = function (url) {
  const v = String(url ?? "").trim();
  if (!v || v.length > QR_URL_MAX) return false;
  try {
    return new URL(v).protocol === "https:";
  } catch {
    return false;
  }
};

// { size, dark(row, col) } or null when the link is missing/invalid.
export const qrMatrix = function (url) {
  if (!isValidQrUrl(url)) return null;
  const qr = qrcode(0, "M");
  qr.addData(String(url).trim());
  qr.make();
  const size = qr.getModuleCount();
  return { size, dark: (r, c) => qr.isDark(r, c) };
};

// Crisp vector QR for the HTML receipt: one <path> of unit squares plus a
// 4-module quiet zone, scaled to `mm` wide.
export const qrSvg = function (url, mm = 28) {
  const m = qrMatrix(url);
  if (!m) return "";
  const q = 4;
  const n = m.size + q * 2;
  let d = "";
  for (let r = 0; r < m.size; r++) {
    for (let c = 0; c < m.size; c++) {
      if (m.dark(r, c)) d += `M${c + q} ${r + q}h1v1h-1z`;
    }
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${n} ${n}" width="${mm}mm" height="${mm}mm" shape-rendering="crispEdges" role="img" aria-label="QR code"><rect width="${n}" height="${n}" fill="#fff"/><path d="${d}" fill="#000"/></svg>`;
};
